/**
 * This object holds all the references for each of the loaded modules.
 * We keep it in a single file to work it as a reference in other parts of the
 * library
 */
const registry = {};

export function getRegistry() {
  return {...registry};
}

/**
 * Returns a module from the registry given its id. 
 * For the standar definition "exports" returns an empty module.
 * @param {string} id
 * @returns {Object} Module reference from the registry
 */
export function getModule(id) {
  return id === 'exports' ? {} : registry[id];
}

/**
 * Build a module from its factory and dependencies.
 * @param {Function} factory
 * @param {Array?} dependencies
 * @returns {Object} Module reference from the registry
 */
export function buildModule(factory, dependencies = []) {
  const dependencyModules = dependencies.map(getModule);
  const factoryOutput = factory.apply(null, dependencyModules);

  const exportsIndex = dependencies.findIndex(dep => dep === 'exports');
  const hasExportsDependency = exportsIndex !== -1;
  const module = hasExportsDependency
    ? dependencyModules[exportsIndex]
    : factoryOutput;

  return module;
}

/**
 * Adds a new attribute to the registry by the given id, then if the factory
 * is a function the value of the new attribute will be the result of the
 * execution of the factory with the given modules as arguments (AMD)
 * @param {String} id
 * @param {Function|Object} factory
 * @param {Array?} dependencies
 * @returns {Object} Module reference from the registry
 */
export function addModule(id, factory, dependencies) {
  registry[id] = typeof factory === 'function'
    ? buildModule(factory, dependencies)
    : factory;

  return registry[id];
}

/**
 * Delete all the declared modules
 * @return {Boolean}
 */
export function resetRegistry() {
  Object.keys(registry).forEach(id => {
    delete registry[id];
  });
  return true;
}
